import Modal from "react-modal";

import IconLoader from "../common/icons/IconLoader";
import styles from "./PopupConfirm.module.scss";

export const PopupConfirm = (props) => {
  const {
    type,
    isOpen,
    onCancel,
    onConfirm,
    inProcess,
    actionFailed,
    labelError = "Error",
    labelNo = "No",
    labelYes = "Yes",
    text = "",
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className={{
        base: styles.popupContent,
        afterOpen: styles.popupContentAfterOpen,
        beforeClose: styles.popupContentBeforeClose,
      }}
      overlayClassName={styles.popupOverlay}
      closeTimeoutMS={200}
    >
      <div className={`${styles.confirm} ${styles[type]}`}>
        <div className={styles.header}>
          <div className={styles.icon}>
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.125 6.25H23.75C24.413 6.25 25.0489 6.51339 25.5178 6.98223C25.9866 7.45107 26.25 8.08696 26.25 8.75V19.375M21.25 13.75H20.625M23.75 23.75H6.25C5.58696 23.75 4.95107 23.4866 4.48223 23.0178C4.01339 22.5489 3.75 21.913 3.75 21.25V8.75C3.75 8.08696 4.01339 7.45107 4.48223 6.98223C4.95107 6.51339 5.58696 6.25 6.25 6.25M2.5 2.5L27.5 27.5M8.75 13.75H13.75M8.75 18.75H11.875"
                stroke="#FC5D2B"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className={styles.body}>
          <>{text}</>
        </div>
        <div className={styles.footer}>
          <button className={styles.no} onClick={onCancel}>
            {labelNo}
          </button>
          {!inProcess && !actionFailed && (
            <button className={styles.yes} onClick={onConfirm}>
              {labelYes}
            </button>
          )}
          {inProcess && !actionFailed && (
            <div className={styles.deleting}>
              <IconLoader />
            </div>
          )}
          {!inProcess && actionFailed && (
            <div className={styles.deleting}>{labelError}</div>
          )}
        </div>
      </div>
    </Modal>
  );
};
